import { ArrowRight, Check } from 'lucide-react'
import { MockShell } from './MockShell'

export function QuoteOrderMock() {
  return (
    <MockShell title="Baha → Sargyt">
      <div className="p-5">
        <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-3">
          {/* Quote */}
          <div className="rounded-xl border border-border p-4 bg-background">
            <div className="flex items-center justify-between mb-2">
              <span className="text-overline text-muted-foreground">Baha</span>
              <span className="text-[10.5px] font-medium px-2 py-0.5 rounded-full bg-[hsl(var(--status-confirmed-bg))] text-[hsl(var(--status-confirmed-text))] border border-[hsl(var(--status-confirmed-border))]">
                Tassyklanan
              </span>
            </div>
            <p className="text-[13px] font-semibold mb-1">Q-2417</p>
            <p className="text-[11px] text-muted-foreground mb-3">
              Senariýa · <span className="text-foreground">Göni</span>
            </p>
            <ul className="space-y-1 text-[11.5px] text-muted-foreground">
              <li>Rotterdam → Warsaw</li>
              <li>Sowadyjy · 33 EP</li>
              <li className="tnum text-foreground">€ 1,413.25</li>
            </ul>
          </div>

          <div className="flex flex-col items-center gap-1">
            <div className="w-9 h-9 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
              <ArrowRight className="w-4 h-4" />
            </div>
            <span className="text-[10px] text-muted-foreground font-medium tracking-wide">
              BIR BASMAK
            </span>
          </div>

          {/* Order */}
          <div className="rounded-xl border border-primary/40 p-4 bg-primary/5">
            <div className="flex items-center justify-between mb-2">
              <span className="text-overline text-primary">Sargyt</span>
              <span className="text-[10.5px] font-medium px-2 py-0.5 rounded-full bg-[hsl(var(--status-transit-bg))] text-[hsl(var(--status-transit-text))] border border-[hsl(var(--status-transit-border))]">
                Ugradylan
              </span>
            </div>
            <p className="text-[13px] font-semibold mb-1">O-1188</p>
            <p className="text-[11px] text-muted-foreground mb-3">Q-2417 · Göni-den</p>
            <ul className="space-y-1 text-[11.5px] text-muted-foreground">
              <li>Rotterdam → Warsaw</li>
              <li>Sowadyjy · 33 EP</li>
              <li className="tnum text-foreground">€ 1,413.25</li>
            </ul>
          </div>
        </div>

        <ul className="mt-5 space-y-1.5 text-[12px] text-muted-foreground">
          {[
            'Sargyt ýeňiji senariýany alýar',
            'Baha audit üçin baglanyşykly bolýar',
            'Maliýe hasap üçin alýar',
          ].map((line) => (
            <li key={line} className="flex items-center gap-2">
              <Check className="w-3 h-3 text-positive" />
              <span>{line}</span>
            </li>
          ))}
        </ul>
      </div>
    </MockShell>
  )
}
